// import React from 'react'

// const CustomPostJobButtonToAdd = () => {
//   return (
//     <div>CustomPostJobButtonToAdd</div>
//   )
// }

// export default CustomPostJobButtonToAdd



import React, { useState } from 'react'
import { styled } from "@mui/material/styles";
import { Container, Box, Paper, Typography, Divider, Grid, Button } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import CustomTable from '../Table/CustomTable';


const ProfileContainer = styled(Box)(({ theme }) => ({
    backgroundColor: "#f5f5f5",
    // minHeight: "100vh",
    padding: theme.spacing(2),
}));


const ResponsiveBox = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    [theme.breakpoints.up("md")]: {
        flexDirection: "row",
    },
}));

const CustomPostJobButtonToAdd = ({ handleViewModal, componentModalName, handleDeletePost, addComponent: AddComponent, title, buttonText, tableData, tableHeadData }) => {
    const [uploadedFile, setUploadedFile] = useState(null);

    const [showEvents, setShowEvents] = useState(false);
    const navigate = useNavigate()
    const handleNavigate = () => {
        navigate(-1)
    }

    const handleAddNavigate = () => {
        setShowEvents(true); // toggle the view
    };

    const handleAddFormGoBackButton = () => {
        setShowEvents(false)
    }


    if (showEvents) {

        return <AddComponent handleAddFormGoBackButton={handleAddFormGoBackButton} />;
    }




    // const handleAddNavigate = () => {
    //     navigate("/eventadd")
    // }

    return (
        <Box>
            <Box data-aos="zoom-in" data-aos-duration="1000"
                sx={{
                    position: 'relative',
                    backgroundColor: "#f5f5f5",

                }}
            >
                <Box>
                    <ProfileContainer p={{ xs: 0 }} mb={2} >
                        <Container maxWidth="lg" >
                            <ResponsiveBox mt={2}>
                                <Paper elevation={3} sx={{ p: 3, flex: 1 }}>
                                    <Typography variant="h6" gutterBottom>{title}</Typography>
                                    <Divider />
                                    <Box>
                                        <Grid size={{ xs: 12 }} sx={{ display: "flex", justifyContent: "start", mt: 2 }}>
                                            <Button
                                                onClick={handleNavigate}

                                                variant="contained"
                                                sx={{
                                                    textTransform: "none",
                                                    color: "black",
                                                    fontSize: "16px",
                                                    padding: { xs: "0px 20px", md: "0px 30px" },
                                                    marginRight: "5px",
                                                    boxShadow: 1,
                                                    border: "1px solid #ced4da",
                                                    minHeight: "40px",
                                                    // borderRadius: "23px",
                                                    background: "white 0% 0% no-repeat padding-box",
                                                    "&:hover": {
                                                        backgroundColor: "white",
                                                    },
                                                }}
                                            >
                                                Go Back
                                            </Button>
                                            <Button
                                                onClick={() => {
                                                    handleAddNavigate()
                                                }}
                                                type="submit"
                                                variant="contained"
                                                sx={{
                                                    textTransform: "none",
                                                    color: "white",
                                                    fontSize: "16px",
                                                    padding: { xs: "0px 20px", md: "0px 50px" },

                                                    boxShadow: "none",
                                                    minHeight: "40px",
                                                    // borderRadius: "23px",
                                                    background: "var(--main-color) 0% 0% no-repeat padding-box",
                                                    "&:hover": {
                                                        backgroundColor: "var(--main-color)",
                                                    },
                                                }}
                                            >
                                                {buttonText}
                                            </Button>
                                        </Grid>
                                    </Box>
                                </Paper>
                            </ResponsiveBox>
                        </Container>
                    </ProfileContainer>
                </Box>
                <Box>
                    <ProfileContainer p={{ xs: 0 }} mb={2} >
                        <Container >
                            <ResponsiveBox mt={2}>
                                <Paper elevation={3} sx={{ p: 3, flex: 1, width: { md: "100px" } }}>
                                    <CustomTable handleDeletePost={handleDeletePost} componentModalName={componentModalName} handleViewModal={handleViewModal} handleAddNavigate={handleAddNavigate} tableReportSearch={false} registrationConfirmed={false} tableActions={true} tableView={true} tableDelete={true} tableData={tableData} tableHeadData={tableHeadData} title="Cygnusa Registration Confirmation" />


                                </Paper>

                            </ResponsiveBox>
                        </Container>
                    </ProfileContainer>
                </Box>
            </Box>

        </Box>
    )
}

export default CustomPostJobButtonToAdd